import { create as C } from "zustand";
import { devtools as O } from "zustand/middleware";
import "./index.es4.js";
import "./index.es20.js";
import "react";
import { usePLMapboxLayersStore as F } from "./index.es12.js";
import "@tanstack/react-query";
import "qs";
import "@turf/turf";
import "./index.es175.js";
import "./index.es176.js";
import "./index.es46.js";
import "./index.es6.js";
import "./index.es99.js";
import "react/jsx-runtime";
import "@placer-ui/components";
import "./index.es203.js";
import "./index.es204.js";
import "./index.es205.js";
import "./index.es206.js";
import "use-debounce";
import "@deck.gl/geo-layers/typed";
import "@deck.gl/core/typed";
import "@deck.gl/layers/typed";
import "react-map-gl";
import "mapbox-gl";
import "fabric";
import "./index.es170.js";
import "lodash/fp";
import "lodash/throttle";
import "lodash/debounce";
import "queue";
import "geobuckets";
import "./index.es207.js";
import "./index.es59.js";
import "./index.es74.js";
import "./index.es82.js";
import "./index.es113.js";
import "@deck.gl/extensions/typed";
import "kdbush";
import "./index.es208.js";
import "./index.es230.js";
import "./index.es231.js";
import "./index.es232.js";
import "./index.es233.js";
import "./index.es234.js";
import "./index.es166.js";
import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";
import "./index.es235.js";
import "@sentry/react";
import "./index.es43.js";
import "lodash";
import "./index.es84.js";
import "./index.es23.js";
import "./index.es18.js";
import "./index.es72.js";
import "@loaders.gl/core";
import "@loaders.gl/mvt";
import "./index.es90.js";
import "./index.es91.js";
import "./index.es92.js";
import "./index.es78.js";
import "./index.es80.js";
import "@deck.gl/aggregation-layers/typed";
import "./index.es86.js";
import "./index.es209.js";
import "./index.es103.js";
import "react-dom";
import "classnames";
import "./index.es210.js";
import "@deck.gl/mapbox/typed";
import "./index.es211.js";
import "./index.es212.js";
import "./index.es213.js";
import "./index.es214.js";
import "./index.es215.js";
import "./index.es216.js";
import "./index.es217.js";
import "./index.es179.js";
import "./index.es218.js";
import "./index.es219.js";
import "./index.es158.js";
import "./index.es220.js";
import "./index.es221.js";
import "./index.es222.js";
import "./index.es223.js";
import "./index.es224.js";
import "@placer-ui/hooks";
import "./index.es225.js";
import "./index.es226.js";
import "./index.es227.js";
import "./index.es228.js";
import "./index.es229.js";
import "./index.es236.js";
import "./index.es137.js";
import "./index.es138.js";
import "./index.es237.js";
import "./index.es238.js";
import "./index.es143.js";
import "./index.es239.js";
import "./index.es35.js";
import "./index.es36.js";
import "./index.es45.js";
import "./index.es39.js";
import "./index.es40.js";
import "zustand/react/shallow";
const P = {
  strokeVisible: !0,
  strokeColor: "#5E63E5",
  strokeOpacity: 100,
  strokeWidth: 2,
  fillVisible: !0,
  fillColor: "#5E63E5",
  fillOpacity: 40
}, Oo = C()(
  O(
    (b, c) => ({
      plDrawRef: void 0,
      setPlDrawRef: (t) => {
        b(() => ({
          plDrawRef: t
        }));
      },
      plmapboxLayerGroupId: void 0,
      setNewPLMapboxLayerGroupId: (t) => {
        var o, r;
        (r = (o = c().plDrawRef) == null ? void 0 : o.mapboxDraw) == null || r.deleteAll(), b(() => ({
          plmapboxLayerGroupId: t,
          editPanelFeatureId: void 0,
          editPanelFeatureType: void 0,
          polygonLastStyle: P,
          lineLastStyle: P
        }));
      },
      editPanelFeatureId: void 0,
      editPanelFeatureType: void 0,
      setEditPanelFeature: (t, o) => {
        (o === "Polygon" || o === "LineString" || o === void 0) && b(() => ({
          editPanelFeatureId: t,
          editPanelFeatureType: o
        }));
      },
      syncFeaturesToPlmapbox: (t) => {
        var a, m, i, l, s, n, y, u, d, L;
        const o = c().plDrawRef, r = c().plmapboxLayerGroupId;
        if (o && r) {
          const f = ((l = (i = (m = (a = F.getState().maps) == null ? void 0 : a[t]) == null ? void 0 : m.layerGroupConfig) == null ? void 0 : i[r]) == null ? void 0 : l.visualFilter) || {}, S = (((L = (d = (u = (y = (n = (s = F.getState().maps) == null ? void 0 : s[t]) == null ? void 0 : n.layerGroupConfig) == null ? void 0 : y[r]) == null ? void 0 : u.fetchFilter) == null ? void 0 : d.geojson) == null ? void 0 : L.features) || []).reduce((p, e) => ({
            ...p,
            [(e == null ? void 0 : e.id) || ""]: e
          }), {}), g = o.getAllFeatures().features.reduce((p, e) => ({
            ...p,
            [(e == null ? void 0 : e.id) || ""]: e
          }), {}), w = {
            ...S,
            ...g
          }, v = Object.values(w), j = Object.keys(w).reduce(
            (p, e) => f[e] ? {
              ...p,
              [e]: f[e]
            } : p,
            {}
          ), x = new Set(
            Object.entries(f).filter(([, p]) => p.visible === !1).map(([p]) => p)
          ), D = v.filter(
            ({ id: p }) => !x.has(p)
          );
          o.mapboxDraw.set({
            type: "FeatureCollection",
            features: D
          });
          const T = F.getState().actions.updateLayerGroupFull;
          T({
            mapId: t,
            layerGroupId: r,
            fetchFilter: {
              geojson: {
                type: "FeatureCollection",
                features: v
              }
            },
            visualFilter: j
          });
        }
      },
      polygonLastStyle: P,
      lineLastStyle: P,
      updateFeature: ({ mapId: t, featureId: o, partialStyle: r, featureName: a, featureVisible: m }) => {
        var l, s, n, y, u;
        const i = c().plmapboxLayerGroupId;
        if (i) {
          const L = {
            ...((u = (y = (n = (s = (l = F.getState().maps) == null ? void 0 : l[t]) == null ? void 0 : s.layerGroupConfig) == null ? void 0 : n[i]) == null ? void 0 : y.visualFilter) == null ? void 0 : u[o]) || {},
            ...r !== void 0 && r,
            ...m !== void 0 && { visible: m },
            ...a !== void 0 && { name: a }
          }, f = F.getState().actions.updateLayerGroup;
          if (f({
            mapId: t,
            layerGroupId: i,
            visualFilter: {
              [o]: L
            }
          }), r) {
            const G = c().getFeatureTypeFromPlmapboxById({
              mapId: t,
              featureId: o
            });
            if (G) {
              const S = c().getLastStyleFieldNameByFeatureType(G);
              b((g) => ({
                ...g,
                [S]: {
                  ...g[S],
                  ...r
                }
              }));
            }
          }
        }
      },
      deleteFeatureById: ({ mapId: t, featureId: o }) => {
        var a, m, i, l, s, n, y, u, d, L, f;
        const r = c().plmapboxLayerGroupId;
        if (r) {
          const G = {
            ...((l = (i = (m = (a = F.getState().maps) == null ? void 0 : a[t]) == null ? void 0 : m.layerGroupConfig) == null ? void 0 : i[r]) == null ? void 0 : l.visualFilter) || {}
          };
          delete G[o];
          const g = (((L = (d = (u = (y = (n = (s = F.getState().maps) == null ? void 0 : s[t]) == null ? void 0 : n.layerGroupConfig) == null ? void 0 : y[r]) == null ? void 0 : u.fetchFilter) == null ? void 0 : d.geojson) == null ? void 0 : L.features) || []).filter(
            ({ id: v }) => v !== o
          ), w = F.getState().actions.updateLayerGroup;
          w({
            mapId: t,
            layerGroupId: r,
            visualFilter: G,
            fetchFilter: {
              geojson: {
                type: "FeatureCollection",
                features: g
              }
            }
          }), (f = c().plDrawRef) == null || f.deleteFeatureById(o);
        }
      },
      getLastStyleFieldNameByFeatureType: (t) => t === "Polygon" ? "polygonLastStyle" : "lineLastStyle",
      getFeatureTypeFromPlmapboxById: ({ mapId: t, featureId: o }) => {
        var a, m, i, l, s, n;
        const r = c().plmapboxLayerGroupId;
        if (r) {
          const u = (((n = (s = (l = (i = (m = (a = F.getState().maps) == null ? void 0 : a[t]) == null ? void 0 : m.layerGroupConfig) == null ? void 0 : i[r || ""]) == null ? void 0 : l.fetchFilter) == null ? void 0 : s.geojson) == null ? void 0 : n.features) || []).find(
            (d) => d.id === o
          );
          if (u)
            return u.geometry.type;
        }
      },
      setDrawPolygonToolCallbacks: ({ onEditClick: t, onDeleteClick: o, onToggleVisible: r }) => {
        b(() => ({
          onEditClick: t,
          onDeleteClick: o,
          onToggleVisible: r
        }));
      }
    }),
    {
      name: "DrawPolygonToolStore",
      enabled: !!(window && window.__REDUX_DEVTOOLS_EXTENSION__),
      stateSanitizer: (b) => ({
        ...b,
        plDrawRef: "refplaceholder"
      })
    }
  )
);
export {
  Oo as useDrawPolygonToolStore
};
//# sourceMappingURL=index.es131.js.map
